// import { domReady } from '@roots/sage/client';

// /**
//  * app.main
//  */
// const common = async (err) => {
//   if (err) {
//     // handle hmr errors
//     console.error(err);
//   }

//   // application code


// /**
//  * Initialize
//  *
//  * @see https://webpack.js.org/api/hot-module-replacement
//  */
// domReady(common);
// import.meta.webpackHot?.accept(common);
